import { useWindowDimensions } from 'react-native';
import { SMALL_SCREEN_MAX_WIDTH } from 'shared/constants/layout';

export const useShouldShowDesktopNavigation = (): boolean => {
  const { width } = useWindowDimensions();

  return width > SMALL_SCREEN_MAX_WIDTH;
};

export default useShouldShowDesktopNavigation;
